<mc-tooltip-panel-wrapper (focusout)="handleFocusOut($event)">
  <!--  [NEW-GROUP] - disabled for ticket DASH-1168-->
  <!--  @if (groupsFeatureFlag) {-->
  <!--    <mc-team-nav-link-group-feature-->
  <!--      (keydown)="buttonTeamPressed($event)"-->
  <!--      (mouseover)="openTeamList()"-->
  <!--      (mouseout)="closeTeamList()"-->
  <!--      [loading]="isLoading()"-->
  <!--      [isSidenavOpened]="isSidenavOpened"-->
  <!--    >-->
  <!--    </mc-team-nav-link-group-feature>-->
  <!--    @if (userMemberships.length) {-->
  <!--      <mc-tooltip-group-feature-panel-->
  <!--        (mouseenter)="openTeamList()"-->
  <!--        (mouseleave)="closeTeamList()"-->
  <!--        (clickOutside)="closeTeamList($event)"-->
  <!--        [forceOpen]="openedTeamList"-->
  <!--        [position]="'bottom'"-->
  <!--        [noHover]="true"-->
  <!--      >-->
  <!--        <div class="nav-items-wrap groups-feature">-->
  <!--          <div class="team-list">-->
  <!--            <div class="team">-->
  <!--              @for (team of userMemberships; track team.myMembershipId) {-->
  <!--                @if (isOwner(team)) {-->
  <!--                  <ng-container *permissionGuard="UserPermissions.manageTeam.showOwnTeam">-->
  <!--                    <mc-team-item-group-feature-->
  <!--                      [team]="team"-->
  <!--                      [userId]="userId"-->
  <!--                      (switchToTeam)="switchToTeam($event)"-->
  <!--                    ></mc-team-item-group-feature>-->
  <!--                  </ng-container>-->
  <!--                } @else {-->
  <!--                  <mc-team-item-group-feature-->
  <!--                    [team]="team"-->
  <!--                    [userId]="userId"-->
  <!--                    (switchToTeam)="switchToTeam($event)"-->
  <!--                  ></mc-team-item-group-feature>-->
  <!--                }-->
  <!--              }-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </mc-tooltip-group-feature-panel>-->
  <!--    }-->
  <!--  } @else {-->
  <!--    <mc-team-nav-link-->
  <!--      (keydown)="buttonTeamPressed($event)"-->
  <!--      (mouseover)="openTeamList()"-->
  <!--      (mouseout)="closeTeamList()"-->
  <!--      [loading]="isLoading()"-->
  <!--      [isSidenavOpened]="isSidenavOpened"-->
  <!--    ></mc-team-nav-link>-->
  <!--    @if (userMemberships.length) {-->
  <!--      <mc-tooltip-panel-->
  <!--        (mouseenter)="openTeamList()"-->
  <!--        (mouseleave)="closeTeamList()"-->
  <!--        (clickOutside)="closeTeamList($event)"-->
  <!--        [forceOpen]="openedTeamList"-->
  <!--        [position]="'bottom'"-->
  <!--        [noHover]="true"-->
  <!--      >-->
  <!--        <div class="nav-items-wrap">-->
  <!--          <div class="team-list">-->
  <!--            <div class="team">-->
  <!--              @for (team of userMemberships; track team.myMembershipId) {-->
  <!--                @if (isOwner(team)) {-->
  <!--                  <ng-container *permissionGuard="UserPermissions.manageTeam.showOwnTeam">-->
  <!--                    <mc-team-item [team]="team" [userId]="userId" (switchToTeam)="switchToTeam($event)"></mc-team-item>-->
  <!--                  </ng-container>-->
  <!--                } @else {-->
  <!--                  <mc-team-item [team]="team" [userId]="userId" (switchToTeam)="switchToTeam($event)"></mc-team-item>-->
  <!--                }-->
  <!--              }-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </mc-tooltip-panel>-->
  <!--    }-->
  <!--  }-->
  <mc-team-nav-link
    (mouseover)="openTeamList()"
    (mouseout)="closeTeamList()"
    (toggleMenu)="onToggleMenu()"
    (moveFocusIntoMenu)="focusMenuItem()"
    (closeMenu)="closeAndFocusButton()"
    [hasMenu]="!!userMemberships.length"
    [menuOpen]="!!openedTeamList"
    [loading]="isLoading()"
    [isSidenavOpened]="isSidenavOpened"
  ></mc-team-nav-link>
  @if (userMemberships.length) {
    <mc-tooltip-panel
      (mouseenter)="openTeamList()"
      (mouseleave)="closeTeamList()"
      (focusin)="openTeamList()"
      (clickOutside)="closeTeamList($event)"
      [forceOpen]="openedTeamList"
      [position]="'bottom'"
      [noHover]="true"
    >
      <div class="nav-items-wrap">
        <div class="team-list" role="menu" aria-label="Switch account" (keydown)="handleMenuKeydown($event)">
          <div class="team">
            @for (team of userMemberships; track team.myMembershipId) {
              @if (isOwner(team)) {
                <ng-container *permissionGuard="UserPermissions.manageTeam.showOwnTeam">
                  <mc-team-item [team]="team" [userId]="userId" (switchToTeam)="switchToTeam($event)"></mc-team-item>
                </ng-container>
              } @else {
                <mc-team-item [team]="team" [userId]="userId" (switchToTeam)="switchToTeam($event)"></mc-team-item>
              }
            }
          </div>
        </div>
      </div>
    </mc-tooltip-panel>
  }
</mc-tooltip-panel-wrapper>
